import Layout from '@/layout';

export default {
  path: '/demo',
  component: Layout,
  meta: {
    title: '首页',
    icon: 'iconfont icon-home',
    code: '010210'
  },
  children: [
    {
      path: '',
      component: () => import('@/views/demo'),
      meta: {
        noPadding: true
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
